import React from 'react'
import UsersStaticsDetailPage from './UsersStaticsDetailPage'

function UsersStaticsDetailContainer(props) {
    return <div className="UsersStaticsDetailContainer">
        <UsersStaticsDetailPage {...props}/>
    </div>
}

export default UsersStaticsDetailContainer
